import { CreateVehicleDto, FormVehicleDto, RowVehicleDto } from "@/dtos";
import { Vehicle, VehicleGroup } from "@/entities";
import { getGeofence, getVehicleStatus } from "@/helpers/options";

export const formatRowVehicleDto = async (vehicles: Vehicle[]): Promise<RowVehicleDto[]> => {
    const result = [] as RowVehicleDto[];

    vehicles.map((x) => {
        const status = getVehicleStatus(parseInt(x.status));
        const geofence = getGeofence(parseInt(x.geofence_type));
        const tableVehicleDto: RowVehicleDto = {
            ...x,
            status_vehicle: status?.label,
            geofence: geofence?.label,
            passenger_capacity: x.passenger_capacity,
            has_connection_medium: x.connectionMediums.length == 0 ? 'No' : 'Si',
            active: x.is_active ? 'Activo' : 'Inactivo',
            extra: x.extra,
            label: x.label
        }
        result.push(tableVehicleDto);
    });

    return result;
}

export const formatVehicleDto = async (formVehicle: FormVehicleDto): Promise<CreateVehicleDto> => {
    const createVehicleDto: CreateVehicleDto = {
        name: formVehicle.name,
        unit_number: formVehicle.unit_number,
        plate_number: formVehicle.plate_number,
        number_foot_passengers: formVehicle.number_foot_passengers,
        number_seats: formVehicle.number_seats,
        passenger_capacity: formVehicle.passenger_capacity,
        geofence_type: formVehicle.geofence_type.toString(),
        status: formVehicle.status.toString(),
        extra: formVehicle.extra,
        label: formVehicle.label,
        vehicle_group: { id: formVehicle.vehicle_group_id } as VehicleGroup
    }
    return createVehicleDto;
}
